import { render, staticRenderFns } from "./ConArticlePageManagement.vue?vue&type=template&id=3c6f995b&"
import script from "./ConArticlePageManagement.vue?vue&type=script&lang=js&"
export * from "./ConArticlePageManagement.vue?vue&type=script&lang=js&"
import style0 from "./ConArticlePageManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports